{
  "TODO": "HACER:",
  "account": "Cuenta",
  "acreInches": "acre-pulgadas",
  "acres": "acres",
  "action": "Acción",
  "action_one": "Acción",
  "action_other": "Comportamiento",
  "actions": "Comportamiento",
  "active": "Activo",
  "alert": "Alerta",
  "appbarLinks": {
    "deviceConnections": "Conexiones",
    "devices": "Dispositivos",
    "fields": "Campos",
    "flowAnalytics": {
      "long": "Análisis de flujo",
      "short": "Analítica"
    },
    "home": "Hogar",
    "schedules": "Horarios",
    "settings": "Ajustes"
  },
  "archived": "Archivado",
  "asOfRelativeTime": "actualizado {{val, relativetime}}",
  "back": "Atrás",
  "cancel": "Cancelar",
  "changeBtn": "Cambiar",
  "changeFarmAccount": "Cambiar la cuenta de la granja",
  "changesSaved": "Cambios guardados.",
  "charging": "Cargando",
  "checkingForUpdates": "Buscando nuevas actualizaciones...",
  "clickToEnlarge": "Haga clic para ampliar",
  "close": "cerca",
  "codaDeviceAlias": "Alias del dispositivo",
  "code": "Código",
  "codeSent": "Código enviado",
  "companyName": "Sede de la granja",
  "confirm": "Confirmar",
  "confirmChanges": "Confirmar cambios",
  "confirmationRequired": "Se requiere confirmación",
  "connections": "Conexiones",
  "contactUs": "Contáctenos",
  "continue": "Continuar",
  "copiedToClipboard": "Copiado al portapapeles.",
  "copy": "Copiar",
  "copyEmailAddress": "Copiar correo electrónico",
  "dataNotAvailable": "Datos no disponibles",
  "datepickersMaxDateTitle": "Fin",
  "datepickersMinDateTitle": "Comenzar",
  "datepickersTitle": "Rango de fechas",
  "datetimeWithVal": "{{val, datetime}}",
  "datetimeWithValAndTimezone": "{{val, datetime}} ({{timezone}})",
  "degrees": "grados",
  "degreesWithVal": "{{val}}°",
  "delete": "Borrar",
  "devOnly": "Solo para desarrolladores",
  "deviceId": "IDENTIFICACIÓN",
  "deviceInstallationType": "Tipo de instalación",
  "deviceInstallationTypes": {
    "center_pivot": "Pivote central",
    "linear_move": "Movimiento lineal",
    "linear_move_controller": "Controlador de movimiento lineal",
    "linear_move_monitor": "Monitor de movimiento lineal",
    "prototype": "Prototipo",
    "pump": "Bomba",
    "pump_off_only": "Bomba (solo apagado)",
    "pump_on_off": "Bomba (Encendido/Apagado)",
    "pump_vfd": "Bomba (VFD)",
    "reel": "Carrete",
    "reel_with_booster_off_only": "Carrete con potenciador (solo apagado)",
    "traveller_soft": "Viajero (manguera blanda)",
    "unconfigured": "Sin configurar",
    "valve": "Válvula"
  },
  "deviceLabelWithDeviceName": "Dispositivo: {{deviceName}}",
  "deviceName": "Nombre del dispositivo",
  "deviceNameWithDeviceInstallationType": "{{deviceName}} ({{deviceInstallationType}})",
  "deviceProfile": "Perfil del dispositivo",
  "device_one": "Dispositivo",
  "device_other": "Dispositivos",
  "devices": "Dispositivos",
  "disabled": "desactivado",
  "discharging": "Descarga",
  "dismiss": "despedir",
  "doNotShowThisAgain": "No mostrar esto nuevamente",
  "done": "Hecho",
  "dragSlider": "Arrastre el control deslizante",
  "dueEast": "Hacia el este",
  "dueNorth": "Hacia el norte",
  "dueSouth": "Hacia el sur",
  "dueWest": "Hacia el oeste",
  "edit": "editar",
  "emailUs": "Envíenos un correo electrónico",
  "enabled": "activado",
  "end": "Fin",
  "event_one": "Evento",
  "event_other": "Eventos",
  "example": "ejemplo",
  "exit": "Salida",
  "experimentalFeatureTitle": "Característica experimental",
  "experimentalFeatureWarning": "Esta función es experimental y es posible que no sea totalmente compatible.",
  "expiresInRelativeTime": "Caduca en {{value, relativetime}}",
  "false": "FALSO",
  "farm": "granja",
  "farmLocation": "Ubicación de la granja",
  "farmScreenTitle": "Granja",
  "farmUserPermissionsTitle": "Permisos de usuario de la granja",
  "field": "Campo",
  "fieldWithCount_one": "campo",
  "field_many": "Campos",
  "fields": "Campos",
  "fieldsWithCount_other": "campos",
  "filter": "Filtrar",
  "firmwareVersion": "Versión de firmware",
  "flipSwath": "Voltear",
  "forbidden": "Prohibido",
  "gettingDeviceActivity": "Obteniendo actividad del dispositivo...",
  "gettingFarm": "Obteniendo datos de la granja...",
  "gettingUser": "Obteniendo datos del usuario...",
  "good": "Bien",
  "goToAnalyticsSite": "Portal de análisis",
  "help": "Ayuda",
  "hint": "Pista",
  "home": "Hogar",
  "horizontal": "horizontal",
  "id": "IDENTIFICACIÓN",
  "lastCheckInWithFallback": "Último check in: hace más de 24 horas",
  "lastCheckInWithVal": "Último check-in: {{val, relativetime}}",
  "loading": "Cargando",
  "loadingEvents": "Cargando eventos...",
  "manage": "Administrar",
  "menu": "Menú",
  "moderate": "Moderado",
  "more": "Más",
  "new": "nuevo",
  "newRule": "Nueva regla",
  "newer": "más nuevo",
  "next": "Próximo",
  "no": "No",
  "noScheduledActions": "No hay acciones programadas",
  "none": "Ninguno",
  "notApplicable": "N / A",
  "notCharging": "No carga",
  "notFound": "Extraviado",
  "notNow": "Ahora no",
  "note": "Nota",
  "noteWithColon": "Nota:",
  "notificationsEnabled": "Notificaciones habilitadas",
  "older": "Más viejo",
  "ongoing": "En curso",
  "oops": "Ups",
  "or": "O",
  "otpFieldLabel": "Introducir código",
  "otpFieldPlaceholder": "XXXXXX",
  "pages": "Páginas",
  "percentSign": "%",
  "percentWithVal": "{{val}}%",
  "poor": "Pobre",
  "preparingDemo": "Preparando el entorno de demostración...",
  "previous": "Anterior",
  "readonly": "Sólo lectura",
  "reelRun": "Carrera de carrete",
  "reelRun_one": "Carrera de carrete",
  "reelRun_other": "El carrete se ejecuta",
  "relativeTimeWithVal": "{{val, relativetime}}",
  "reportAProblem": "Reportar un problema",
  "requestSentToDevice": "Solicitud enviada al dispositivo...",
  "resendCode": "Reenviar código",
  "result": "Resultado",
  "reviewAndSubmit": "Revisar y enviar",
  "save": "ahorrar",
  "select": "Seleccionar",
  "selected": "seleccionado",
  "self": "Ser",
  "sensorNameWithLabel": "{{sensorName}} Sensor",
  "sensorWithSensorName": "{{sensorName}} Sensor",
  "sensor_many": "sensores",
  "sensor_one": "sensor",
  "settings": "Ajustes",
  "showLess": "Mostrar menos",
  "showMore": "Mostrar más",
  "signOut": "Desconectar",
  "skipForNow": "Saltar por ahora",
  "offlineErrorMessage": "Estás sin conexión. Comprueba tu conexión e inténtalo de nuevo.",
  "offlineIndicator": "Sin conexión",
  "permissionDeniedErrorMessage": "No tienes permiso para hacer esto.",
  "somethingWentWrong": "Algo salió mal.",
  "sort": "clasificar",
  "sourceDevice": "Dispositivo fuente",
  "start": "Comenzar",
  "startOver": "Empezar de nuevo",
  "submit": "Entregar",
  "success": "Éxito",
  "support": "Apoyo",
  "targetDevice": "Dispositivo de destino",
  "time": "Tiempo",
  "true": "Verdadero",
  "undo": "deshacer",
  "unknown": "Desconocido",
  "valWithColon": "{{val}}:",
  "verifiedFalse": "No verificado",
  "verifiedTrue": "Verificado",
  "warning": "Advertencia",
  "welcome": "Bienvenido",
  "whyDoWeCollectThis": "¿Por qué recopilamos esta información?",
  "yes": "Sí"
}
